import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import { Button, FormControl, Paper, Typography, Radio, RadioGroup, Box } from '@material-ui/core';
import { Dialog, AppBar, Toolbar, FormControlLabel, Slide } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { DisplayMessage, GetFormattedDate } from '../../../../services/helpers.js';
import { TimePicker } from 'antd';
import moment from 'moment';
import appFetch from '../../../../api/appFetch.js';
import { OutletUserTimetableDetailsWithOutletUserIdOutletIdAndDateUrl, PlanningAbsencesUrl } from '../../../../constants/apiUrls.js';
import AbsenceReasonsDropdown from '../../../Common/Dropdowns/AbsenceReasonsDropdown.js';
import OutletsDropdown from '../../../Common/Dropdowns/OutletsDropdown.js';
import OutletUsersDropdown from '../../../Common/Dropdowns/OutletUsersDropdown.js';
import DatePickerComponent from '../../../Common/DatePickers/DatePickerComponent.js';
import { withPlanningSettings } from '../../../../utils/withPlanningSettings.js';

const format = 'HH:mm';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class AbsenceNew extends Component {
    constructor(props) {
        super(props);

        var outlets = [];
        if (this.props.accessibleMoboOutlets !== undefined) {
            outlets = this.props.accessibleMoboOutlets.sort((a, b) => (a.description.toLowerCase().localeCompare(b.description.toLowerCase())))
        }

        const outletId = this.props.outletId !== undefined ? parseInt(this.props.outletId) : outlets[0].id;

        this.state = {
            outletUserId: 0,
            requestInProgress: false,
            openPopup: true,
            dateFrom: "",
            absentHourFrom: null,
            absentHourTill: null,
            absentFrom: "",
            absentTill: "",
            duration: "1",
            reasons: [],
            reason: "",
            outlets: outlets,
            outletId: outletId,
        };

        // Notify the HOC about the initial outlet
        if (this.props.onOutletChangeForSettings && outletId) {
            this.props.onOutletChangeForSettings(outletId);
        }
    }

    handleDateFrom = value => {
        this.setState({ absentHourFrom: null, absentHourTill: null, dateFrom: value }, () => this.getTimetables());
    };

    handleChangeOutlet = e => {
        var id = e.target.value
        this.setState({ outletId: id }, () => {
            this.getTimetables();
            // Notify the HOC about the outlet change to fetch new settings
            if (this.props.onOutletChangeForSettings) {
                this.props.onOutletChangeForSettings(id);
            }
        });
    };

    handleAbsentFrom = value => {
        if (value > this.state.absentTill) {
            this.setState({ absentTill: "" });
        }

        this.setState({ absentFrom: value });
    };

    handleAbsentTill = value => {
        this.setState({ absentTill: value });
    };

    validateData = (absentFrom, absentTill) => {
        var resources = this.props.resources;

        if (this.state.outletUserId < 1) {
            DisplayMessage(resources["InvalidOutletUser"], "error");
            return false;
        }

        if (this.state.duration == 1) {
            if (this.state.dateFrom === "" || this.state.absentHourFrom === null || this.state.absentHourTill === null || this.state.absentHourFrom > this.state.absentHourTill) {
                DisplayMessage(resources["InvalidAbsentHours"], "error");
                return false;
            }
        }
        else {
            if (this.state.duration == 2 && absentFrom > absentTill) {
                DisplayMessage(resources["InvalidAbsentTill"], "error");
                return false;
            }
        }

        if (this.state.reason == "none") {
            DisplayMessage(resources["InvalidReason"], "error");
            return false;
        }

        return true;
    }

    isValidForm = () => {
        const { outletUserId, duration, reason, absentHourFrom, absentHourTill, absentFrom, absentTill, dateFrom } = this.state;

        if (!outletUserId || outletUserId < 1) {
            return false;
        }

        if (parseInt(duration) === 1) {
            if (!dateFrom || !absentHourFrom || !absentHourTill) {
                return false;
            }

            const momentDateFrom = moment(dateFrom, "YYYY/MM/DD");
            const momentAbsentHourFrom = moment(absentHourFrom, "HH:mm");
            const momentAbsentHourTill = moment(absentHourTill, "HH:mm");

            if (!momentDateFrom.isValid() || !momentAbsentHourFrom.isValid() || !momentAbsentHourTill.isValid() || !momentAbsentHourTill.isAfter(momentAbsentHourFrom)) {
                return false;
            }
        }
        else if (parseInt(duration) === 2) {
            if (!absentFrom || !absentTill) {
                return false;
            }

            const momentAbsentFrom = moment(absentFrom, "YYYY/MM/DD");
            const momentAbsentTill = moment(absentTill, "YYYY/MM/DD");

            if (!momentAbsentFrom.isValid() || !momentAbsentTill.isValid() || momentAbsentTill.isBefore(momentAbsentFrom)) {
                return false;
            }
        }

        if (!reason || reason === "none") {
            return false;
        }

        return true;
    }

    saveNewAbsence = () => {
        let absentFrom;
        let absentTill;

        if (this.state.duration == 1) {
            if (!this.validateData(absentFrom, absentTill)) {
                return;
            }

            absentFrom = this.state.dateFrom + " " + this.state.absentHourFrom;
            absentTill = this.state.dateFrom + " " + this.state.absentHourTill;
        }

        if (this.state.duration == 2) {
            absentFrom = GetFormattedDate(this.state.absentFrom == "" ? undefined : this.state.absentFrom);
            absentTill = GetFormattedDate(this.state.absentTill == "" ? undefined : this.state.absentTill);
            if (!this.validateData(absentFrom, absentTill)) {
                return;
            }
        }

        let resources = this.props.resources;
        this.setState({ requestInProgress: true });

        var json = JSON.stringify({
            assignedTo: this.state.outletUserId,
            moboOutletId: this.state.outletId,
            absentFrom: absentFrom,
            absentTill: absentTill,
            absenceTypeId: parseInt(this.state.reason),
        });

        const url = PlanningAbsencesUrl();

        appFetch({
            url: url,
            method: 'POST',
            body: json,
            onSuccess: (data) => {
                DisplayMessage(resources["NewAbsenceWasSaved"], "success");
                this.setState({ redirect: "/absences", absenceWasCreated: true });
            },
            onError: (data) => {
                for (var i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    handleClose = () => {
        this.setState({ redirect: "/absences" });
    }

    handleChangeOutletUser = e => {
        this.setState({ outletUserId: parseInt(e.target.value) }, () => this.getTimetables());
    };

    handleDuration(duration) {

        if (duration !== undefined) this.setState({ duration: duration });
    }

    handleChangeReason = e => {
        this.setState({ reason: e.target.value });
    };

    getTimetables() {
        if (this.state.outletUserId < 1 || this.state.outletId < 1 || this.state.dateFrom === "") {
            return;
        }

        this.setState({ requestInProgress: true });

        const url = OutletUserTimetableDetailsWithOutletUserIdOutletIdAndDateUrl(this.state.outletUserId, this.state.outletId, this.state.dateFrom);

        appFetch({
            url: url,
            onSuccess: (data) => {
                this.setState({
                    absentHourFrom: data.startOfDay.substring(0, 5),
                    absentHourTill: data.endOfDay.substring(0, 5),
                    fetchingData: false
                });
            },
            onError: (data, response) => {
                if (response.errors !== undefined) {
                    for (var i = 0; i < response.errors.length; i++) {
                        DisplayMessage(response.errors[i], "error");
                    }
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    handleChangeTimetableInput = (value, inputType) => {
        this.setState({ [inputType]: value === '' ? null : value });
    }

    renderForm() {
        const { redirect, requestInProgress, absenceWasCreated, openPopup, outletUserId, dateFrom, absentFrom, absentTill, absentHourFrom, absentHourTill, reason, duration } = this.state;
        const { resources } = this.props;
        const canEdit = this.props.canUseAgendasAndAbsencesInSettings !== false;

        var helperTextAbsentHourFrom = absentHourFrom === "" ? "helper-text-red" : "helper-text-grey";
        var helperTextAbsentHourTill = absentHourTill === "" ? "helper-text-red" : "helper-text-grey";

        var isOneDayDuration = duration == "1";
        var isMoreThanOneDayDuration = duration == "2";

        var displayOnDayOrLess = isOneDayDuration ? "flex" : "none";
        var displayMoreThanOneDay = isMoreThanOneDayDuration ? "flex" : "none";

        if (redirect) {
            return <Redirect to={{ pathname: this.state.redirect, state: { absenceWasCreated } }} />
        }

        const handleSubmit = (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.saveNewAbsence();
        };

        const isSaveButtonDisabled = requestInProgress || !this.isValidForm() || redirect || !canEdit

        return (
            <Dialog fullScreen open={openPopup} onClose={this.handleClose} TransitionComponent={Transition}>
                <Form onSubmit={handleSubmit} >
                    <AppBar className="position-sticky">
                        <Toolbar>
                            <IconButton edge="start" id="close-edit-absence" color="inherit" onClick={this.handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" style={{ flex: 1 }}>
                                {resources["AddNewAbsenceTitle"]}
                            </Typography>
                            <Button id="absence-save" color="inherit" type="submit" disabled={isSaveButtonDisabled}>{resources["Save"]}</Button>
                        </Toolbar>
                    </AppBar>

                    <div className="container">
                        <div className="py-4 grey">
                            {!canEdit && (
                                <Typography variant="body2" color="error" align="center" style={{ marginBottom: 0 }}>
                                    {resources["UseShiftsFunctionalityToManageAgendasOrAbsences"]}
                                </Typography>
                            )}
                            <Paper elevation={3} className="p-4 mt-3 mb-3">

                                <Form.Group style={{ display: "flex", width: "100%", justifyContent: "center" }}>
                                    <div className="col-lg-3 d-none d-xs-block"></div>
                                    <OutletsDropdown
                                        resources={resources}
                                        outlets={this.props.accessibleMoboOutlets}
                                        outlet={this.state.outletId}
                                        onOutletChange={this.handleChangeOutlet}
                                        containerClass="col-lg-6 col-12"
                                        filterFunction={x => x.hasWorkshopPlanning || x.hasWorkshopPlanningLight}
                                        noPlaceholder
                                    />
                                </Form.Group>

                                <Form.Group style={{ display: "flex", width: "100%", justifyContent: "center" }}>
                                    <div className="col-lg-3 d-none d-xs-block"></div>
                                    <OutletUsersDropdown
                                        resources={resources}
                                        outletUser={outletUserId}
                                        onOutletUserChange={this.handleChangeOutletUser}
                                        onRequestStart={() => this.setState({ requestInProgress: true })}
                                        onRequestEnd={() => this.setState({ requestInProgress: false })}
                                        containerClass="col-lg-6 col-12"
                                        helperText={resources["SelectionOfUserIsMandatory"]}
                                        required
                                        disabled={!canEdit}
                                    />
                                    <div className="col-lg-3 d-none d-xs-block"></div>
                                </Form.Group>


                                <Form.Group style={{ display: "flex", width: "100%", justifyContent: "left" }}  >
                                    <div className="col-3"> </div>
                                    <div className="col-6">
                                        <span style={{ fontSize: "0.8rem" }}>{resources["Duration"]}</span>
                                        <RadioGroup defaultValue={this.state.duration} value={this.state.duration} onClick={(e) => canEdit && this.handleDuration(e.target.value)}>
                                            <FormControlLabel value="1" control={<Radio disabled={!canEdit} />} label={resources["OneDayOrLess"]} />
                                            <FormControlLabel value="2" control={<Radio disabled={!canEdit} />} label={resources["MoreThanOneDay"]} />
                                        </RadioGroup>
                                    </div>
                                </Form.Group>

                                <Form.Group id="divOneDayOrLess" style={{ display: displayOnDayOrLess, width: "100%", justifyContent: "left" }}  >
                                    <div className="col-lg-3  d-xs-block"></div>
                                    <DatePickerComponent
                                        id="oneDayOrLess"
                                        label={resources["OneDayAbsenceDate"]}
                                        value={dateFrom}
                                        onChange={this.handleDateFrom}
                                        error={!dateFrom && isOneDayDuration}
                                        helperText={resources["PleasePickADate"]}
                                        minDate={new Date("2000-01-01")}
                                        required={isOneDayDuration}
                                        disabled={!canEdit}
                                    />
                                    <div className="col-lg-3 d-none d-xs-block"></div>
                                </Form.Group>
                                <Form.Group id="divOneDayOrLess1" style={{ display: displayOnDayOrLess, width: "100%", justifyContent: "center" }}  >
                                    <FormControl className={"col-lg-3 col-6 " + helperTextAbsentHourFrom}>
                                        <TimePicker className="white-date mr-2" minuteStep={5} placeholder={resources["AbsentFromTime"]} format={format} name="absentHourFrom" value={absentHourFrom !== null ? moment(absentHourFrom, format) : null} onChange={(time, timeString) => this.handleChangeTimetableInput(timeString, "absentHourFrom")} disabled={!canEdit} />
                                    </FormControl>
                                    <FormControl className={"col-lg-3 col-6 " + helperTextAbsentHourTill}>
                                        <TimePicker className="white-date " minuteStep={5} placeholder={resources["AbsentTillTime"]} format={format} name="absentHourTill" value={absentHourTill !== null ? moment(absentHourTill, format) : null} onChange={(time, timeString) => this.handleChangeTimetableInput(timeString, "absentHourTill")} disabled={!canEdit} />
                                    </FormControl>
                                    <div className="col-lg-3 d-none d-xs-block"></div>
                                </Form.Group>

                                <Form.Group id="divMoreThatnOneDay" style={{ display: displayMoreThanOneDay, width: "100%", justifyContent: "center" }}  >
                                    <div className="col-lg-3 d-none d-xs-block"></div>
                                    <Box display="flex" justifyContent="space-between" className='col-6' padding="0" gap="15px">
                                        <DatePickerComponent
                                            id="moreThatnOneDayFrom"
                                            label={resources["MoreDayAbsentFrom"]}
                                            value={absentFrom}
                                            onChange={this.handleAbsentFrom}
                                            error={!absentFrom && isMoreThanOneDayDuration}
                                            helperText={resources["PleasePickADate"]}
                                            minDate={new Date("2000-01-01")}
                                            required={isMoreThanOneDayDuration}
                                            disabled={!canEdit}
                                        />
                                        <DatePickerComponent
                                            id="moreThatnOneDayTill"
                                            label={resources["MoreDaysAbsentTill"]}
                                            value={absentTill}
                                            onChange={this.handleAbsentTill}
                                            error={!absentTill && isMoreThanOneDayDuration}
                                            helperText={resources["PleasePickADate"]}
                                            minDate={absentFrom != "" ? new Date(this.state.absentFrom) : new Date("2000-01-01")}
                                            required={isMoreThanOneDayDuration}
                                            disabled={!canEdit}
                                        />
                                    </Box>
                                    <div className="col-lg-3 d-none d-xs-block"></div>
                                </Form.Group>

                                <Form.Group style={{ display: "flex", width: "100%", justifyContent: "center" }}>
                                    <div className="col-lg-3 d-none d-xs-block"></div>
                                    <AbsenceReasonsDropdown
                                        resources={resources}
                                        absenceReason={reason}
                                        onAbsenceReasonChange={this.handleChangeReason}
                                        onRequestStart={() => this.setState({ requestInProgress: true })}
                                        onRequestEnd={() => this.setState({ requestInProgress: false })}
                                        containerClass="col-lg-6 col-12"
                                        helperText={resources["ReasonHelperText"]}
                                        required
                                        disabled={!canEdit}
                                    />
                                    <div className="col-lg-3 d-none d-xs-block"></div>
                                </Form.Group>
                            </Paper>
                        </div>
                    </div>
                </Form>
            </Dialog >
        );
    }

    render() {
        return (
            <div className={"pt-4 grey text-center" + (this.state.loading ? 'fadeOut' : 'fadeIn')} >
                <div className="container">
                    {this.renderForm()}
                </div>
            </div>
        );
    }
}

export default withPlanningSettings(AbsenceNew);
